// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3I5Sj","buttons":"SendReceipts_buttons__3-sCD","email":"SendReceipts_email__1jmmt","bookApptTitle":"SendReceipts_bookApptTitle__2a9ai"};